export default __webpack_public_path__ + "static/banner-four-shape3-170918365268761eb2e1dd0718e6ed2b.png";